const STEPS = [
  { title: "Send the brief", body: "Photos, dimensions and any CAD or reference files, plus where the images will run." },
  { title: "Free sample first", body: "For qualifying sellers we render a short sample of one product before you pay." },
  { title: "Approve a preview", body: "A low-res clay and lighting preview comes back first so changes are cheap." },
  { title: "Final render and delivery", body: "Full-quality files in the sizes you asked for, with revision rounds included." },
];

export function Process() {
  return (
    <section className="t-process" data-section="process">
      <header className="t-highlights-head">
        <h2 className="t-section-title">How it works</h2>
      </header>
      <ol className="t-highlight-index">
        {STEPS.map((s, i) => (
          <li key={s.title} className="t-highlight-row">
            <span className="t-highlight-num" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="t-highlight-body">
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
